import { render, staticRenderFns } from "./WeekDayBtn.vue?vue&type=template&id=674a7efc"
import script from "./WeekDayBtn.vue?vue&type=script&lang=js"
export * from "./WeekDayBtn.vue?vue&type=script&lang=js"
import style0 from "./WeekDayBtn.vue?vue&type=style&index=0&id=674a7efc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports